import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Bitcoin, Loader, CheckCircle, XCircle } from 'lucide-react';
import './PaymentPage.css';

const PaymentPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [paymentStatus, setPaymentStatus] = useState('idle');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    setPaymentStatus('checking');
    // In a real scenario, this would check with the backend
    setTimeout(() => {
      setPaymentStatus('success');
    }, 2000);
  };

  const renderContent = () => {
    if (sessionId) {
      if (paymentStatus === 'checking') {
        return (
          <div className="payment-status" data-testid="payment-status-checking">
            <Loader size={64} className="spinner-icon" />
            <h2 data-testid="checking-title">Verifying Payment...</h2>
            <p data-testid="checking-subtitle">Please wait while we confirm your transaction</p>
          </div>
        );
      }

      if (paymentStatus === 'success') {
        return (
          <div className="payment-status success" data-testid="payment-status-success">
            <CheckCircle size={64} />
            <h2 data-testid="success-title">Payment Successful!</h2>
            <p data-testid="success-subtitle">Your payment has been processed successfully</p>
            <button 
              className="btn btn-primary mt-4" 
              onClick={() => navigate('/')}
              data-testid="back-home-btn"
            >
              Back to Home
            </button>
          </div>
        );
      }

      return (
        <div className="payment-status error" data-testid="payment-status-error">
          <XCircle size={64} />
          <h2 data-testid="error-title">Payment Failed</h2>
          <p data-testid="error-subtitle">Something went wrong with your payment</p>
          <button 
            className="btn btn-primary mt-4" 
            onClick={() => navigate('/')}
            data-testid="try-again-btn"
          >
            Try Again
          </button>
        </div>
      );
    }

    return (
      <div className="payment-demo" data-testid="payment-demo">
        <div className="demo-card" data-testid="demo-card">
          <div className="demo-icon" data-testid="demo-icon">
            <Bitcoin size={48} />
          </div>
          <h2 className="demo-title" data-testid="demo-title">Crypto Payment Demo</h2>
          <p className="demo-description" data-testid="demo-description">
            This is a demo payment page. Sign up for an account to create your own payment links
            and start accepting crypto payments from customers worldwide.
          </p>
          <div className="demo-features" data-testid="demo-features">
            <div className="demo-feature" data-testid="demo-feature-0">
              <CheckCircle size={20} />
              <span>Accept Bitcoin, Ethereum, USDC, and more</span>
            </div>
            <div className="demo-feature" data-testid="demo-feature-1">
              <CheckCircle size={20} />
              <span>Auto-convert to fiat currency</span>
            </div>
            <div className="demo-feature" data-testid="demo-feature-2">
              <CheckCircle size={20} />
              <span>Direct deposit to your bank account</span>
            </div>
            <div className="demo-feature" data-testid="demo-feature-3">
              <CheckCircle size={20} />
              <span>Apple Pay integration</span>
            </div>
          </div>
          <button 
            className="btn btn-primary btn-large" 
            onClick={() => navigate('/auth')}
            data-testid="get-started-demo-btn"
          >
            Get Started Now
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="payment-page" data-testid="payment-page">
      <div className="payment-container">
        <div className="payment-header" data-testid="payment-header">
          <div className="logo" onClick={() => navigate('/')} data-testid="payment-logo">
            <Bitcoin size={32} />
            <span>Crypto Cashier</span>
          </div>
        </div>
        {renderContent()}
      </div>
    </div>
  );
};

export default PaymentPage;